<template>
  <div class="dg-articles-page">
    <!-- 面包屑导航 -->
    <nav class="breadcrumb-nav">
      <router-link to="/">首页</router-link>
      <span class="separator">/</span>
      <router-link to="/consulting/data-governance">数据治理咨询</router-link>
      <span class="separator">/</span>
      <span class="current">专题文章</span>
    </nav>

    <div class="container">
      <!-- 页面标题 -->
      <div class="page-header">
        <h1 class="page-title">数据治理专题文章</h1>
        <p class="page-desc">精选数据治理体系、标准建设、主数据管理、数据质量、资产盘点等深度内容，助力企业构建可落地的数据治理能力。</p>
      </div>

      <!-- 筛选栏 -->
      <div class="filter-bar">
        <div class="filter-tabs">
          <span class="filter-tab" :class="{ active: activeCategory === 'all' }" @click="activeCategory = 'all'">全部</span>
          <span class="filter-tab" :class="{ active: activeCategory === 'framework' }" @click="activeCategory = 'framework'">治理体系</span>
          <span class="filter-tab" :class="{ active: activeCategory === 'finance' }" @click="activeCategory = 'finance'">财务数字化</span>
          <span class="filter-tab" :class="{ active: activeCategory === 'training' }" @click="activeCategory = 'training'">基础培训</span>
          <span class="filter-tab" :class="{ active: activeCategory === 'ai' }" @click="activeCategory = 'ai'">AI与数据治理</span>
          <span class="filter-tab" :class="{ active: activeCategory === 'consulting' }" @click="activeCategory = 'consulting'">咨询参考</span>
        </div>
        <div class="search-box">
          <input type="text" class="search-input" placeholder="搜索文章..." v-model="searchKeyword" @keyup.enter="searchArticles">
          <button class="search-btn" @click="searchArticles">搜索</button>
        </div>
      </div>

      <!-- 文章列表 -->
      <div class="article-list">
        <div class="article-item" v-for="article in filteredArticles" :key="article.id" @click="openArticle(article.url)">
          <div class="article-meta">
            <span class="article-date">{{ article.date }}</span>
            <div class="article-tags">
              <span class="article-tag" v-for="tag in article.tags" :key="tag">{{ tag }}</span>
            </div>
          </div>
          <h2 class="article-title">{{ article.title }}</h2>
          <p class="article-summary">{{ article.summary }}</p>
          <div class="article-footer">
            <span class="read-more">阅读全文 <i class="fas fa-arrow-right"></i></span>
            <span class="article-stats"><i class="fas fa-eye"></i> {{ article.views }}</span>
          </div>
        </div>
      </div>

      <!-- 分页 -->
      <div class="pagination">
        <span class="page-btn" @click="changePage(currentPage - 1)"><i class="fas fa-chevron-left"></i></span>
        <span class="page-btn" v-for="p in totalPages" :key="p" :class="{ active: currentPage === p }" @click="changePage(p)">{{ p }}</span>
        <span class="page-btn next" @click="changePage(currentPage + 1)">下一页 <i class="fas fa-chevron-right"></i></span>
      </div>

      <!-- 推荐文章侧栏 -->
      <div class="sidebar">
        <h3 class="sidebar-title">热门推荐</h3>
        <ul class="recommend-list">
          <li class="recommend-item" @click="openArticle('https://mp.weixin.qq.com/s/sd4q0SdF8WigNXDxdbLJCA?scene=1&click_id=24')">• 2026年生成式AI下的数据治理现状</li>
          <li class="recommend-item" @click="openArticle('https://mp.weixin.qq.com/s/OM0M7hTucRHOeLPW6iom2A?scene=1&click_id=27')">• 数据治理治的不是数据</li>
          <li class="recommend-item" @click="openArticle('https://mp.weixin.qq.com/s/t8gg0GMHIDX_jl1_o1596Q?scene=1')">• 原创｜财务数字化转型：华为数据方案模型</li>
          <li class="recommend-item" @click="openArticle('https://mp.weixin.qq.com/s/WoNjryFQlCtl1e44gp6Etw?scene=1')">• 数据治理体系构建-2025</li>
          <li class="recommend-item" @click="openArticle('https://mp.weixin.qq.com/s/QhTGmF8qqXJ2SPD_Lkh6-g?scene=1&click_id=21')">• 麦肯锡-数据治理（部分参考）</li>
        </ul>
      </div>
    </div>

    <!-- 底部转化模块 -->
    <section id="contact">
      <div class="container">
        <div class="cta-section">
          <div class="cta-title">获取更多数据治理深度内容</div>
          <p style="font-size: 18px; margin-bottom: 30px;">订阅我们的邮件，每周获取最新数据治理实践文章与行业报告</p>
          <button class="btn-primary" @click="showSubscribeModal = true">立即订阅</button>
        </div>
      </div>
    </section>

    <!-- 订阅弹窗 -->
    <div class="modal-overlay" v-if="showSubscribeModal" @click.self="showSubscribeModal = false">
      <div class="modal-container">
        <span class="modal-close" @click="showSubscribeModal = false">&times;</span>
        <h3 style="margin-bottom: 20px;">订阅数据治理专题</h3>
        <form @submit.prevent="submitSubscribe">
          <div style="margin-bottom: 15px;">
            <input type="text" placeholder="姓名" style="width:100%; padding:12px; border-radius:8px; border:1px solid #ddd;">
          </div>
          <div style="margin-bottom: 15px;">
            <input type="email" placeholder="企业邮箱 *" style="width:100%; padding:12px; border-radius:8px; border:1px solid #ddd;">
          </div>
          <div style="margin-bottom: 15px;">
            <input type="text" placeholder="公司名称" style="width:100%; padding:12px; border-radius:8px; border:1px solid #ddd;">
          </div>
          <button class="btn-primary" style="width:100%;">确认订阅</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataGovernanceArticles',
  data() {
    return {
      activeCategory: 'all',
      searchKeyword: '',
      searchActive: false,
      currentPage: 1,
      showSubscribeModal: false,
      articles: [
        {
          id: 1, category: 'finance', date: '2025-06-10',
          tags: ['财务域', '数据治理', '数字化转型'],
          title: '财务数字化转型与数据治理(财务域)',
          summary: '聚焦财务领域数字化转型，探讨如何通过数据治理实现财务流程标准化、数据资产化，助力企业提升财务管理效率与决策能力。',
          views: '2.1k阅读',
          url: 'https://mp.weixin.qq.com/s/IJWqr5FpAUJVI8N4Ib21rQ?scene=1&click_id=17'
        },
        {
          id: 2, category: 'training', date: '2025-05-15',
          tags: ['基础培训', '数据治理', '入门'],
          title: '数据治理-基础培训',
          summary: '系统讲解数据治理的基本概念、核心框架与实施路径，适合企业数据管理人员入门学习，快速建立数据治理知识体系。',
          views: '1.8k阅读',
          url: 'https://mp.weixin.qq.com/s/HpgPFVH2yOrHtR9tacMKlw?scene=1'
        },
        {
          id: 3, category: 'framework', date: '2025-04-20',
          tags: ['治理理念', '组织管理', '原创'],
          title: '数据治理治的不是数据',
          summary: '深度解析数据治理的本质——治理的不是数据本身，而是管理数据的人、流程和制度，从组织、文化、机制角度重新认识数据治理。',
          views: '2.5k阅读',
          url: 'https://mp.weixin.qq.com/s/OM0M7hTucRHOeLPW6iom2A?scene=1&click_id=27'
        },
        {
          id: 4, category: 'framework', date: '2025-03-28',
          tags: ['治理体系', '体系构建', '2025'],
          title: '数据治理体系构建-2025',
          summary: '基于2025年最新实践，系统阐述数据治理体系的组织架构、制度流程、技术平台与评估机制，提供完整的体系构建方法论。',
          views: '2.3k阅读',
          url: 'https://mp.weixin.qq.com/s/WoNjryFQlCtl1e44gp6Etw?scene=1'
        },
        {
          id: 5, category: 'ai', date: '2026-01-15',
          tags: ['生成式AI', '数据治理', 'PDF下载'],
          title: '2026年生成式AI下的数据治理现状（附pdf下载)',
          summary: '探讨生成式AI时代数据治理面临的新挑战与机遇，分析AI驱动下数据质量、合规、安全的最新趋势，附完整PDF报告下载。',
          views: '3.1k阅读',
          url: 'https://mp.weixin.qq.com/s/sd4q0SdF8WigNXDxdbLJCA?scene=1&click_id=24'
        },
        {
          id: 6, category: 'finance', date: '2025-07-05',
          tags: ['华为', '财务转型', '数据方案'],
          title: '原创｜财务数字化转型：华为数据方案模型',
          summary: '深度剖析华为财务数字化转型的数据方案模型，从数据架构、标准体系、技术平台到应用场景，分享华为实践经验与方法论。',
          views: '2.8k阅读',
          url: 'https://mp.weixin.qq.com/s/t8gg0GMHIDX_jl1_o1596Q?scene=1'
        },
        {
          id: 7, category: 'consulting', date: '2025-02-10',
          tags: ['麦肯锡', '数据治理', '咨询参考'],
          title: '麦肯锡-数据治理（部分参考）',
          summary: '整理麦肯锡关于数据治理的核心观点与方法论，涵盖治理框架、组织设计、数据质量管理等内容，为企业数据治理提供国际视野参考。',
          views: '2.0k阅读',
          url: 'https://mp.weixin.qq.com/s/QhTGmF8qqXJ2SPD_Lkh6-g?scene=1&click_id=21'
        },
        {
          id: 8, category: 'finance', date: '2025-08-12',
          tags: ['财务核算', '标准化', '原创'],
          title: '原创｜财务数字化转型：如何为财务核算标准化注入"灵魂"',
          summary: '探讨财务核算标准化的深层逻辑，从会计科目、核算规则、数据映射等维度，阐述如何让标准化从"形似"走向"神似"。',
          views: '1.6k阅读',
          url: 'https://mp.weixin.qq.com/s/Ho_9xvL5vTtzUBr4jdZfKA?scene=1&click_id=18'
        }
      ]
    }
  },
  computed: {
    filteredArticles() {
      let list = this.articles
      if (this.activeCategory !== 'all') {
        list = list.filter(a => a.category === this.activeCategory)
      }
      if (this.searchActive && this.searchKeyword) {
        const kw = this.searchKeyword.toLowerCase()
        list = list.filter(a =>
          a.title.toLowerCase().includes(kw) ||
          a.summary.toLowerCase().includes(kw)
        )
      }
      return list
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.filteredArticles.length / 6)) || 1
    }
  },
  methods: {
    searchArticles() {
      this.searchActive = true
    },
    changePage(p) {
      if (p >= 1 && p <= this.totalPages) {
        this.currentPage = p
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    },
    openArticle(url) {
      window.open(url, '_blank')
    },
    submitSubscribe() {
      alert('订阅成功！')
      this.showSubscribeModal = false
    }
  },
  watch: {
    activeCategory() {
      this.currentPage = 1
    },
    searchKeyword(val) {
      if (!val) this.searchActive = false
    }
  }
}
</script>

<style scoped>
.dg-articles-page {
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  background-color: #ffffff;
  color: #2B2F3A;
  line-height: 1.6;
  --primary-blue: #1F3F8F;
  --deep-indigo: #0E1F52;
  --light-porcelain: #EAF0FB;
  --bg-light: #f5f7fa;
  --text-dark: #2B2F3A;
  --card-shadow: 0 12px 28px rgba(0,10,30,0.04), 0 4px 16px rgba(31,63,143,0.08);
  --border-light: #e9edf4;
  --nav-height: 60px;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
}

/* 面包屑 */
.breadcrumb-nav {
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px 24px;
  font-size: 14px;
  color: #5f6a7d;
}
.breadcrumb-nav a {
  color: #1F3F8F;
  text-decoration: none;
}
.breadcrumb-nav a:hover {
  text-decoration: underline;
}
.breadcrumb-nav .separator {
  margin: 0 8px;
  color: #ccc;
}
.breadcrumb-nav .current {
  color: #2B2F3A;
}

/* 页面标题 */
.page-header {
  margin-bottom: 40px;
  margin-top: 20px;
}
.page-title {
  font-size: 38px;
  font-weight: 700;
  color: var(--deep-indigo);
  margin-bottom: 16px;
}
.page-desc {
  font-size: 18px;
  color: #5f6a7d;
  max-width: 800px;
}

/* 筛选栏 */
.filter-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
  flex-wrap: wrap;
  gap: 20px;
}
.filter-tabs {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.filter-tab {
  padding: 8px 24px;
  border-radius: 40px;
  background: white;
  border: 1px solid var(--border-light);
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
}
.filter-tab.active, .filter-tab:hover {
  background: var(--primary-blue);
  color: white;
  border-color: var(--primary-blue);
}
.search-box {
  display: flex;
  gap: 8px;
}
.search-input {
  padding: 10px 16px;
  border-radius: 40px;
  border: 1px solid var(--border-light);
  width: 250px;
  font-size: 14px;
}
.search-btn {
  padding: 10px 24px;
  border-radius: 40px;
  background: var(--primary-blue);
  color: white;
  border: none;
  cursor: pointer;
  transition: 0.3s;
}
.search-btn:hover {
  background: #0e3170;
}

/* 文章列表 */
.article-list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 30px;
  margin-bottom: 50px;
}
.article-item {
  background: white;
  border-radius: 16px;
  padding: 32px;
  box-shadow: var(--card-shadow);
  transition: all 0.3s;
  cursor: pointer;
  border: 1px solid rgba(31,63,143,0.05);
}
.article-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 24px 40px rgba(31,63,143,0.12);
}
.article-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;
}
.article-date {
  color: #5f6a7d;
  font-size: 14px;
}
.article-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.article-tag {
  background: var(--light-porcelain);
  padding: 4px 12px;
  border-radius: 40px;
  font-size: 12px;
  color: var(--primary-blue);
}
.article-title {
  font-size: 24px;
  font-weight: 600;
  color: var(--deep-indigo);
  margin-bottom: 12px;
}
.article-summary {
  color: #5f6a7d;
  margin-bottom: 20px;
  line-height: 1.7;
}
.article-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.read-more {
  color: var(--primary-blue);
  text-decoration: none;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: gap 0.3s;
}
.article-item:hover .read-more {
  gap: 12px;
}
.article-stats {
  font-size: 14px;
  color: #8a95a8;
}

/* 分页 */
.pagination {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin: 60px 0;
}
.page-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border: 1px solid var(--border-light);
  cursor: pointer;
  transition: all 0.3s;
}
.page-btn:hover, .page-btn.active {
  background: var(--primary-blue);
  color: white;
  border-color: var(--primary-blue);
}
.page-btn.next {
  width: auto;
  padding: 0 16px;
  border-radius: 40px;
}

/* 推荐文章侧栏 */
.sidebar {
  background: var(--bg-light);
  border-radius: 16px;
  padding: 24px;
  margin-top: 40px;
}
.sidebar-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  color: var(--deep-indigo);
}
.recommend-list {
  list-style: none;
  padding: 0;
}
.recommend-item {
  padding: 12px 0;
  border-bottom: 1px solid var(--border-light);
  cursor: pointer;
  transition: color 0.3s;
}
.recommend-item:hover {
  color: var(--primary-blue);
}

/* 底部转化 */
.cta-section {
  background: var(--deep-indigo);
  border-radius: 32px;
  padding: 60px;
  color: white;
  text-align: center;
  margin: 60px 0;
}
.cta-title {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 16px;
}
.btn-primary {
  display: inline-block;
  background: var(--primary-blue);
  color: white;
  border: none;
  padding: 14px 36px;
  border-radius: 60px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s;
  text-decoration: none;
  font-size: 16px;
}
.btn-primary:hover {
  background: #0e3170;
  transform: translateY(-2px);
}

/* 弹窗 */
.modal-overlay {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(11,26,51,0.6);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-container {
  background: white;
  border-radius: 32px;
  padding: 40px;
  max-width: 500px;
  width: 90%;
}
.modal-close {
  float: right;
  font-size: 24px;
  cursor: pointer;
}

@media (max-width: 768px) {
  .filter-bar {
    flex-direction: column;
    align-items: stretch;
  }
  .search-box {
    width: 100%;
  }
  .search-input {
    width: 100%;
  }
  .page-title {
    font-size: 28px;
  }
}
</style>
